import React, { useEffect, useState } from 'react';
import './DataDetailsOutFolder.css';

import { Button, Select, Table } from 'antd';
import { IoMdAdd } from 'react-icons/io';
import { PiClipboardTextFill } from 'react-icons/pi';
// import SearchIcon from "../../../../../Assets/SearchIcon.svg";
// import editIcon from "../../../../../Assets/editPencil.svg";
import { MdKeyboardBackspace } from 'react-icons/md';
import CreateOutputFormat from '../../../../Build/From/CreateOutputFormat/CreateOutputFormat';
import { useParams } from 'react-router-dom';
import { workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesDataDetails';
import { workspaces_Support_Documents_Output_Edit_Data_Details_ActionHandler } from '../../../../../Redux/Actions/user/workspacesSupportDocumentsOutputEditDataDetails';
import { useDispatch, useSelector } from 'react-redux';
import EditSupportDocumentOutput from '../../../../Build/From/EditOutputFormat/EditSupportDocumentOutput/EditSupportDocumentOutput';
import EditOwnDataSupportDocumentOutput from '../../../../Build/From/EditOutputFormat/EditOwnDataSupportDocumentOutput/EditOwnDataSupportDocumentOutput';
import Swal from 'sweetalert2';
import { MdOutlineDelete } from 'react-icons/md';
import { SupportingDocumentOutputDeleteHandler } from '../../../../../Redux/Actions/user/SupportingOutputDocumentsDelete';
let { Option } = Select;
const DataDetailsOutFolder = ({
    setDatadetalisoutputid,
    setworkspacefoldername,
    permissionsDetails,
    handleClickBack,
}) => {
    let SearchIcon = '/assets/SearchIcon.svg';
    let editIcon = '/assets/editPencil.svg';

    let dispatch = useDispatch();
    const parms = useParams();
    const workspace_id = parms.id;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState(null);
    const [isCreateOutputFormat, setIsCreateOutputFormat] = useState(false);
    const [isEditOutputData, setIsEditOutputData] = useState(false);
    const [isEditOwnDataOutputData, setIsOwnDataOutputData] = useState(false);
    const [editOutputData, setEditOutputData] = useState([]);
    const [isFileType, setIsFileType] = useState(null);
    const workspaceSupportDocumentsOutputEditData = useSelector(
        (state) =>
            state?.WorkspaceSupportDocumentsOutputEditData
                ?.workspace_support_documents_output_edit_data?.data
    );
    const workspaceDataDetailsoutputData = useSelector(
        (state) =>
            state?.workspaces_Data_Details_Data
                ?.workspace_data_details_out_put_data?.data
    );
    const columns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        {
            title: 'Created By',
            dataIndex: 'created_by',
            key: 'created_by',
            render: (text, record) => <>{record.created_by.first_name}</>,
        },
        { title: 'Type', dataIndex: 'type', key: 'type' },
        {
            title: 'Edit',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <div
                    className='cursor_pointer'
                    onClick={() => handleEditClick(record.id, record.type)}>
                    <img src={editIcon} alt='' />
                </div>
            ),
        },
        {
            title: 'Delete',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <>
                    {permissionsDetails.includes(
                        'create-delete-reference-data'
                    ) ? (
                        <MdOutlineDelete
                            className='DeleteIcon'
                            onClick={() => handleDeleteRole(record.id)}
                        />
                    ) : (
                        <MdOutlineDelete className='DeleteIcon permision-not-allowed-css' />
                    )}
                </>
            ),
        },
    ];
    const handleDeleteRole = (id) => {
        if (id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this Output Templates?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Output Templates has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    dispatch(SupportingDocumentOutputDeleteHandler(id));
                    setTimeout(() => {
                        dispatch(
                            workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                                workspace_id,
                                setDatadetalisoutputid,
                                '',
                                '',
                                currentPage
                            )
                        );
                    }, 1000);
                }
            });
        }
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(
            workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                workspace_id,
                setDatadetalisoutputid,
                '',
                '',
                page
            )
        );
    };
    const handleEditClick = (Id, type) => {
        setIsEditOutputData(false);
        setIsOwnDataOutputData(false);
        setIsFileType(type);
        if (Id && type) {
            dispatch(
                workspaces_Support_Documents_Output_Edit_Data_Details_ActionHandler(
                    Id
                )
            );
        }
        dispatch(
            workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                workspace_id,
                setDatadetalisoutputid,
                '',
                '',
                currentPage
            )
        );
    };
    useEffect(() => {
        if (workspaceSupportDocumentsOutputEditData) {
            setEditOutputData(workspaceSupportDocumentsOutputEditData);
            if (isFileType === 'file') {
                setIsEditOutputData(!isEditOutputData);
            }
            if (isFileType === 'text') {
                setIsOwnDataOutputData(!isEditOwnDataOutputData);
            }
        }
    }, [workspaceSupportDocumentsOutputEditData]);
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSearch = debounce((e) => {
        let value = e.target.value;
        let encodedValue = encodeURIComponent(value);
        if (encodedValue?.length) {
            setSearchValue(encodedValue);
        }
        if (!encodedValue.length) {
            dispatch(
                workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                    workspace_id,
                    setDatadetalisoutputid,
                    '',
                    '',
                    currentPage
                )
            );
        }
    }, 1000);
    const handleCreateOutputFormat = () => {
        dispatch(
            workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                workspace_id,
                setDatadetalisoutputid,
                '',
                '',
                currentPage
            )
        );
        setIsCreateOutputFormat(!isCreateOutputFormat);
    };
    useEffect(() => {
        if (searchValue?.length > 3) {
            dispatch(
                workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                    workspace_id,
                    setDatadetalisoutputid,
                    searchValue,
                    '',
                    currentPage
                )
            );
        }
    }, [searchValue]);
    useEffect(() => {
        if (workspace_id && setDatadetalisoutputid) {
            dispatch(
                workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                    workspace_id,
                    setDatadetalisoutputid,
                    '',
                    '',
                    currentPage
                )
            );
        }
    }, [workspace_id, setDatadetalisoutputid]);
    const handleSortChange = (sortvalue) => {
        dispatch(
            workspaces_Support_Documents_Data_Details_Out_Put_List_ActionHandler(
                workspace_id,
                setDatadetalisoutputid,
                '',
                sortvalue,
                currentPage
            )
        );
    };

    return (
        <div className='workspace-container'>
            <div className='data-details-folder-main-1'>
                <p>
                    <PiClipboardTextFill />
                    Output Templates (
                    {workspaceDataDetailsoutputData?.total || 0})
                </p>
                <div>
                    <h4
                        className='cursor'
                        onClick={() => handleClickBack(false)}>
                        <MdKeyboardBackspace />
                        Back to Folder
                    </h4>
                    {permissionsDetails?.includes(
                        'create-delete-reference-data'
                    ) ? (
                        <Button
                            className='main-api'
                            onClick={handleCreateOutputFormat}>
                            <IoMdAdd />
                            Add Files
                        </Button>
                    ) : (
                        <Button className='main-api permision-not-allowed-css'>
                            <IoMdAdd />
                            Add Files
                        </Button>
                    )}
                </div>
            </div>
            <div className='brand-text'>{setworkspacefoldername}</div>
            <div className='data-details-folder-main-2'>
                <div className='relative search-container'>
                    <input
                        created_by='text'
                        placeholder='Search Documents here...'
                        className='search-from-logs'
                        onChange={(e) => handleSearch(e)}
                    />
                    <img src={SearchIcon} alt='' className='search-icon' />
                </div>
                <div>
                    <Select
                        defaultValue='Sort By'
                        style={{ width: 120, height: '36px' }}
                        onChange={handleSortChange}>
                        <Option value='name'> Name</Option>
                        <Option value='created_at'> Created At</Option>
                    </Select>
                </div>
            </div>
            <div className='data-details-folder-main-3'>
                <Table
                    columns={columns}
                    dataSource={workspaceDataDetailsoutputData?.data}
                    bordered
                    size='middle'
                    // pagination={{
                    //     pageSize: workspaceDataDetailsoutputData?.per_page,
                    // }}
                    pagination={{
                        pageSize: workspaceDataDetailsoutputData?.per_page,
                        total: workspaceDataDetailsoutputData?.total,
                        showSizeChanger: false,
                        onChange: handlePageChange,
                    }}
                    className='mytable'
                />
            </div>
            {isCreateOutputFormat ? (
                <CreateOutputFormat
                    isCreateOutputFormat={isCreateOutputFormat}
                    handleCreateOutputFormat={handleCreateOutputFormat}
                    workspaceFolderFlag={true}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisoutputid}
                />
            ) : null}
            {isEditOutputData ? (
                <EditSupportDocumentOutput
                    isEditOutputData={isEditOutputData}
                    handleEditClick={handleEditClick}
                    editOutputData={editOutputData}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisoutputid}
                    workspaceFolderFlag={true}
                />
            ) : null}
            {isEditOwnDataOutputData ? (
                <EditOwnDataSupportDocumentOutput
                    isEditOwnDataOutputData={isEditOwnDataOutputData}
                    handleEditClick={handleEditClick}
                    editOutputData={editOutputData}
                    workspace_id={workspace_id}
                    folder_id={setDatadetalisoutputid}
                    workspaceFolderFlag={true}
                />
            ) : null}
        </div>
    );
};

export default DataDetailsOutFolder;
